import React from 'react';
import { Box, Typography } from '@mui/material';

interface FrontsiteMapViewProps {
  analytics: {
    uniqueCompanies: number;
    totalRecords: number;
    completedOrders: number;
    totalRevenue: number;
  };
}

const FrontsiteMapView: React.FC<FrontsiteMapViewProps> = ({ analytics }) => {
  const cards = [
    {
      key: 'uniqueCompanies',
      label: 'Unique Companies',
      value: analytics.uniqueCompanies.toLocaleString(),
      background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
      color: '#312e81',
    },
    {
      key: 'totalRecords',
      label: 'Total Records',
      value: analytics.totalRecords.toLocaleString(),
      background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
      color: '#92400e',
    },
    {
      key: 'completedOrders',
      label: 'Completed Orders',
      value: analytics.completedOrders.toLocaleString(),
      background: 'linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)',
      color: '#065f46',
    },
    {
      key: 'totalRevenue',
      label: 'Total Revenue',
      value: `$${analytics.totalRevenue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
      background: 'linear-gradient(135deg, #fff7ed 0%, #fde8d5 100%)',
      color: '#9a3412',
    },
  ];

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 16,
        bottom: 88,
        zIndex: 1000,
        background: '#ffffff',
        borderRadius: '70px',
        boxShadow: '0 6px 16px rgba(0,0,0,0.10)',
        padding: '10px 16px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.25,
        border: '1px solid #e9ecef',
        minWidth: { xs: '90vw', md: 'auto' },
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        {cards.map((card) => (
          <Box
            key={card.key}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              padding: '4px 10px',
              borderRadius: '999px',
              border: '1px solid #e2e8f0',
              background: '#f8fafc',
            }}
          >
            <svg width="12" height="18" viewBox="0 0 384 512" style={{ display: 'inline-block' }}>
              <path
                fill={card.color}
                stroke="white"
                strokeWidth="16"
                d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
              />
            </svg>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
              <Typography variant="caption" sx={{ color: '#475569', textTransform: 'uppercase', letterSpacing: 0.6 }}>
                {card.label}
              </Typography>
              <Typography variant="body2" sx={{ color: card.color, fontWeight: 700 }}>
                {card.value}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default FrontsiteMapView;
